<template>
  <div :class="['table-cell', { stacked }]">
    <slot />
  </div>
</template>

<script setup lang="ts">
/** A cell of a `TableRow`; `stacked` puts its lines under each other, for a name with a note beneath */
defineProps<{ stacked?: boolean }>();
</script>

<style scoped lang="scss">
.table-cell {
  display: flex;
  align-items: center;
  gap: var(--t-spacing-sm);
  min-width: 0;
  overflow-wrap: anywhere;

  &.stacked {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--t-spacing-xs);
  }
}
</style>
